module.exports = __webpack_public_path__ + "static/img/Fuel-Poverty_SSD_8311.ae64598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Fuel-Poverty_SSD_8311.jpg
// module id = Buy5
// module chunks = 0